module.exports = __webpack_public_path__ + "static/media/simplyWhiteFront.5bac3479.PNG";